var _circle, _circle2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "url(#paint0_linear_1486_2096)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 29C31.43 29 33 27.43 33 25.5C33 23.57 31.43 22 29.5 22C27.57 22 26 23.57 26 25.5C26 27.43 27.57 29 29.5 29ZM29.5 24C30.33 24 31 24.67 31 25.5C31 26.33 30.33 27 29.5 27C28.67 27 28 26.33 28 25.5C28 24.67 28.67 24 29.5 24ZM29.5 30.75C27.16 30.75 22.5 31.92 22.5 34.25V35C22.5 35.55 22.95 36 23.5 36H35.5C36.05 36 36.5 35.55 36.5 35V34.25C36.5 31.92 31.84 30.75 29.5 30.75ZM24.84 34C25.68 33.42 27.71 32.75 29.5 32.75C31.29 32.75 33.32 33.42 34.16 34H24.84ZM36.54 30.81C37.7 31.65 38.5 32.77 38.5 34.25V36H41.5C42.05 36 42.5 35.55 42.5 35V34.25C42.5 32.23 39 31.08 36.54 30.81ZM35.5 29C37.43 29 39 27.43 39 25.5C39 23.57 37.43 22 35.5 22C34.96 22 34.46 22.13 34 22.35C34.63 23.24 35 24.33 35 25.5C35 26.67 34.63 27.76 34 28.65C34.46 28.87 34.96 29 35.5 29Z",
    fill: "url(#paint1_linear_1486_2096)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.96 30.81C21.8 31.65 21 32.77 21 34.25V36H18C17.45 36 17 35.55 17 35V34.25C17 32.23 20.5 31.08 22.96 30.81ZM24 29C22.07 29 20.5 27.43 20.5 25.5C20.5 23.57 22.07 22 24 22C24.54 22 25.04 22.13 25.5 22.35C24.87 23.24 24.5 24.33 24.5 25.5C24.5 26.67 24.87 27.76 25.5 28.65C25.04 28.87 24.54 29 24 29Z",
    fill: "url(#paint2_linear_1486_2096)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_2096",
    x1: 29,
    y1: 118.484,
    x2: 29,
    y2: -14.9677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_2096",
    x1: 32.5,
    y1: 50.5996,
    x2: 32.5,
    y2: 18.3871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1486_2096",
    x1: 21.25,
    y1: 50.5996,
    x2: 21.25,
    y2: 18.3871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTwo);
export default __webpack_public_path__ + "static/media/featuresTwo.207b83a0ab644194188096b008153d85.svg";
export { ForwardRef as ReactComponent };